export interface ReviewRatings {
  rating_avg: number;
  rating_cnt: number;
  ratings: {
    1: number;
    2: number;
    3: number;
    4: number;
    5: number;
  };
}

export interface ServerReviewRatingsResponse {
  result_code: number;
  data: ReviewRatings;
  lang: string;
  userID: string | null;
}


